import styled from 'styled-components';
import { Icon } from '@web-chat-core/ui-kit';

export const RecordIconBase = styled(Icon)`
    --ic-outer-color: ${(props) => props.theme.root.colors.basicColors['90%']};
    --ic-inner-color: ${(props) => props.theme.root.colors.system.dangerDefault};
`;
